import { memo } from 'react';

export const VentanaLogo = memo(({ className = "", size = "default" }) => {
  const sizes = {
    small: { height: 32 },
    default: { height: 44 },
    large: { height: 56 }
  };
  
  const { height } = sizes[size] || sizes.default;
  
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* Airplane Window Image */}
      <img 
        src="https://customer-assets.emergentagent.com/job_ventana-views/artifacts/u0xlczsv_IMG_0125.jpeg"
        alt="Ventana"
        style={{ height: height, width: 'auto' }}
        className="rounded-lg"
      />
      
      {/* Ventana Text in Times New Roman */}
      <span 
        style={{ 
          fontFamily: "'Times New Roman', Times, serif",
          fontSize: height * 0.55,
          fontWeight: 400,
          letterSpacing: '0.02em',
          background: 'linear-gradient(135deg, #C77DFF 0%, #F72585 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }}
      >
        Ventana
      </span>
    </div>
  );
});

VentanaLogo.displayName = 'VentanaLogo';
